'use strict';
class Subscribe {
	constructor(props = {}) {
		// console.log('Subscribe::constructor(%o)', props);
		let _that = this;

		_that.elements = {
			email_input: document.getElementById('email_input'),
			subscribe_form: document.getElementById('subscribe_form'),
			subscribe_button: document.getElementById('email_subscribe'),
			subscribe_form_message: document.getElementById('form_subscribe_newsletter_message'),
			warning_sign: document.getElementById('warning_sign')
		};

		_that = Object.assign(this, props);

		_that.pageEvents();
	}

	pageEvents() {
		const _that = this;

		if (_that.elements.warning_sign) {
			console.warn('there is warning');
			_that.elements.warning_sign.addEventListener('click', function () {
				_that.elements.email_input.value = '';
				_that.elements.subscribe_form.classList.remove('has-error');
				_that.elements.subscribe_button.classList.remove('btn-red');
				_that.elements.subscribe_button.classList.add('btn-orange');
				_that.elements.email_input.focus();
			});
		}

		if (_that.elements.email_input) {
			_that.elements.email_input.addEventListener('input', function () {
				if (valid_email(_that.elements.email_input.value)) {
					_that.elements.subscribe_form.classList.remove('has-error');
					_that.elements.subscribe_button.classList.remove('btn-red');
					_that.elements.subscribe_button.classList.add('btn-orange');
				}
			});
		}

		if (_that.elements.subscribe_form) {
			_that.elements.subscribe_form.addEventListener('submit', function (event) {
				event.preventDefault();
				if (_that.elements.email_input.value === '' || !valid_email(_that.elements.email_input.value)) {
					_that.elements.subscribe_form.classList.add('has-error');
					_that.elements.subscribe_button.classList.remove('btn-orange');
					_that.elements.subscribe_button.classList.add('btn-red');
					_that.elements.email_input.focus();
					_that.elements.subscribe_form_message.innerHTML = '';
					_that.elements.subscribe_form_message.classList.remove('alert', 'alert-danger', 'alert-success');
					return false;
				} else {
					_that.elements.subscribe_button.disabled = true;

					const form_message = _that.elements.subscribe_form_message;
					const form_data = new FormData();
					form_data.append('email', _that.elements.subscribe_form.querySelector('#email_input')?.value);
					form_data.append('_token', _that.elements.subscribe_form.querySelector('input[name="_token"]')?.value);

					const fetch = fetcher(
						url('process_newsletter'),
						{
							method: 'post',
							body: form_data
						}
					);

					fetch.ready.then((response) => {
						if (response.error) {
							form_message.classList.remove('alert-success');

							form_message.classList.add('alert', 'alert-danger');
							form_message.innerHTML = response.error;
						} else if (response.success) {
							form_message.classList.remove('alert-danger');

							form_message.classList.add('alert', 'alert-success');
							form_message.innerHTML = response.success;
						}
						_that.elements.subscribe_button.disabled = false;
					})
					return false;
				}
			});
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new Subscribe();
	} catch (error) {
		console.error(error);
	}
});
